export default {"src":"/_next/static/media/logo-with-light-text.064252da.svg","height":38,"width":218,"blurWidth":0,"blurHeight":0};